export default __webpack_public_path__ + "static/media/1-Ano-01-Por-Onde-Eu-Ando.bf67175d.png";